
import React, { PureComponent } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { css } from 'aphrodite/no-important';

import styles from './styles.js';

import { mapActions } from '../../actions';

import Translatable from '../../../../components/Translatable';
import GoogleMap from './GoogleMap';

const IS_BROWSER = typeof window !== 'undefined';

class MapSection extends PureComponent {
    static propTypes = {
        contentLoading: PropTypes.bool.isRequired,
        initialContentLoaded: PropTypes.bool.isRequired,
        mapState: PropTypes.object.isRequired,
        toggleSearchOnMapMove: PropTypes.func.isRequired,
        unstable: PropTypes.bool.isRequired
    }

    render() {
        const {
            contentLoading,
            initialContentLoaded,
            mapState,
            toggleSearchOnMapMove,
            unstable
        } = this.props;
        return (
            <div
                className={
                    mapState.mapPanelVisible ?
                        css(
                            styles.mapWrapper,
                            styles.mapWrapper_withTabs,
                            styles.mapPanelVisible
                        ) : css(
                            styles.mapWrapper,
                            styles.mapWrapper_withTabs,
                            styles.mapPanelHidden
                        )
                }
            >
                <div>
                    <div>
                        <div
                            style={{
                                position: 'relative',
                                top: '0px',
                                zIndex: 1
                            }}
                        >
                            <div className={css(styles.searchResultsMapContainer)}>
                                <div
                                    aria-hidden="true"
                                    style={{
                                        height: '100%'
                                    }}
                                >
                                    {
                                        (!initialContentLoaded || contentLoading || unstable) &&
                                        <div className={css(styles.mapOverlay)} />
                                    }
                                    {
                                        IS_BROWSER &&
                                        <GoogleMap />
                                    }
                                    <div className={css(styles.mapRefreshControls)}>
                                        <div className={css(styles.panel, styles.mapAutoRefresh)}>
                                            <label
                                                className={css(styles.checkbox)}
                                                htmlFor="map-auto-refresh-checkbox"
                                            >
                                                <input
                                                    className={css(styles.refreshInput)}
                                                    id="map-auto-refresh-checkbox"
                                                    value="on"
                                                    type="checkbox"
                                                    onChange={toggleSearchOnMapMove}
                                                />
                                                <span
                                                    data-fake-checkbox="true"
                                                    className={
                                                        mapState.searchOnMapMove ?
                                                            css(styles.fakeCheckboxChecked) :
                                                            css(styles.fakeCheckbox)
                                                    }
                                                >
                                                    {
                                                        mapState.searchOnMapMove ?
                                                            <span className={css(styles.fakeCheckboxCheckmark)}>
                                                                <svg
                                                                    className={css(styles.fakeCheckboxCheckmarkSvg)}
                                                                    viewBox="0 0 52 52"
                                                                    fill="currentColor"
                                                                    fillOpacity="0"
                                                                    stroke="#ffffff"
                                                                    strokeWidth="3"
                                                                    aria-hidden="true"
                                                                    role="presentation"
                                                                    strokeLinecap="round"
                                                                    strokeLinejoin="round"
                                                                >
                                                                    <path d="M19.1 25.2l4.7 6.2 12.1-11.2" />
                                                                </svg>
                                                            </span> : null
                                                    }
                                                </span>
                                                <Translatable
                                                    className={css(styles.refreshText)}
                                                    content={{
                                                        transKey: 'search.move_map'
                                                    }}
                                                />
                                            </label>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

const mapStateToProps = state => ({
    contentLoading: state.contentLoading,
    initialContentLoaded: state.initialContentLoaded,
    mapState: state.mapState,
    lang: state.lang,
    unstable: state.mapState.unstable
});

const mapDispatchToProps = dispatch => {
    return {
        toggleSearchOnMapMove: () => dispatch(mapActions.toggleSearchOnMapMove())
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(MapSection);



// WEBPACK FOOTER //
// ./src/pages/Search/Main/MapSection/MapSection.jsx